<template>
  <a-upload
    name="file"
    accept="image/png, image/jpeg, image/gif, image/webp"
    list-type="picture-card"
    class="course-cover-uploader"
    :show-upload-list="false"
    action="https://newbase.zhihuishu.com/upload/commonUploadFile"
    :before-upload="beforeUpload"
    @change="handleChange"
    :data="{moduleName: 'livecourse-server'}"
  >
    上传按钮
  </a-upload>
</template>
<script>

export default {
  name: 'UploadImg',
  data() {
    return {
      loading: false,
      imageUrl: '',
    };
  },
  methods: {
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true;
        this.$emit('updateUpload', {loading: this.loading})
        return;
      }
      if (info.file.status === 'error') {
        this.loading = false;
        this.$message.error('上传失败，请重试！')
        this.$emit('updateUpload', {loading: this.loading})
        return;
      }
      if (info.file.status === 'done') {
        const { status, rt } = info.file.response
        const result = rt || {}
        this.loading = false;
        if (status != 200 || !result.url) {
          this.$message.error('上传失败，请重试！')
          return
        }
        this.imageUrl = result.url;
        this.$emit('updateUpload', {loading: this.loading, imageUrl: this.imageUrl})
      }
    },
    beforeUpload(file) {
      // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      // if (!isJpgOrPng) {
      //   this.$message.error('只能上传格式为jpeg、png的图片');
      // }
      const isLtMb = file.size / 1024 / 1024 < 5;
      if (!isLtMb) {
        this.$message.error('图片不能超过 5MB!');
      }
      return isLtMb;
    },
  },
};
</script>
<style lang="scss" >
.course-cover-uploader{
  width: 100%;
  height: 100%;
  opacity: 0;
}
.course-cover-uploader .ant-upload {
  width: 100%;
  height: 100%;
  &.ant-upload-select-picture-card{
    margin: 0;
  }
}

</style>
